/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostLiffSignedurlUploadVideo200Response
 */
export interface PostLiffSignedurlUploadVideo200Response {
    /**
     * 
     * @type {string}
     * @memberof PostLiffSignedurlUploadVideo200Response
     */
    signedUrl: string;
    /**
     * 
     * @type {object}
     * @memberof PostLiffSignedurlUploadVideo200Response
     */
    fields: object;
}

/**
 * Check if a given object implements the PostLiffSignedurlUploadVideo200Response interface.
 */
export function instanceOfPostLiffSignedurlUploadVideo200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "signedUrl" in value;
    isInstance = isInstance && "fields" in value;

    return isInstance;
}

export function PostLiffSignedurlUploadVideo200ResponseFromJSON(json: any): PostLiffSignedurlUploadVideo200Response {
    return PostLiffSignedurlUploadVideo200ResponseFromJSONTyped(json, false);
}

export function PostLiffSignedurlUploadVideo200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostLiffSignedurlUploadVideo200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'signedUrl': json['signedUrl'],
        'fields': json['fields'],
    };
}

export function PostLiffSignedurlUploadVideo200ResponseToJSON(value?: PostLiffSignedurlUploadVideo200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'signedUrl': value.signedUrl,
        'fields': value.fields,
    };
}

